
import axios from "axios";
import { defineComponent } from "vue";
export default defineComponent({
  name: "dr.patient-connection",
  data() {
    return {
      doctors: [] ,
      patients: [],
      idDoctor: "لطفا یک مورد را انتخاب کنید",
      idPatient: "لطفا یک مورد را انتخاب کنید",
      isNullDoctors: false,
      isNullPatients: false,
    };
  },
  methods: {
    fetchDoctors() {
      axios
        .get("/doctors")
        .then((res) => {
          // console.log(res.data);
          this.doctors = res.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    fetchPatients() {
      axios
        .get("/patients")
        .then((res) => {
          //  console.log(res.data);
          this.patients = res.data;
        })
        .catch((error) => {
          console.log(error.status);
        });
    },
    save() {
      let sccess = false;
      if (this.idDoctor === "لطفا یک مورد را انتخاب کنید") {
        this.isNullDoctors = true;
      } else {
        this.isNullDoctors = false;
        sccess = true;
      }
      if (this.idPatient === "لطفا یک مورد را انتخاب کنید") {
        this.isNullPatients = true;
      } else {
        this.isNullPatients = false;
        sccess = true;
      }
      if (
        sccess == true &&
        this.isNullDoctors == false &&
        this.isNullPatients == false
      ) {
        axios
          .post("/operator/relation", {
            patient_id: this.idPatient,
            doctor_id: this.idDoctor,
          })
          .then((res) => {
            if (res.status == 200) {
              window.alert("تغییرات با موفقیت انجام شد!");
              this.idDoctor = "لطفا یک مورد را انتخاب کنید";
              this.idPatient = "لطفا یک مورد را انتخاب کنید";
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
  },
  mounted() {
    this.fetchDoctors();
    this.fetchPatients();
  },
});
